import BrokerSiteIcon from '../icons/brokerSite.svg';
import SelfEmployeedIcon from '../icons/selfEmployed.svg';
export var getFirstAdvantageIcon = function getFirstAdvantageIcon(isSelfEmployedInfo) {
  if (isSelfEmployedInfo) {
    return SelfEmployeedIcon;
  }
  return BrokerSiteIcon;
};